import {UP_FAILURE, UP_PENDING, UP_SUCCESS} from './constants'
import {getUserPermissions as getUserPermissionsApi} from '../../services/user'
// import permissionsJson from '../../fixtures/user_permissions.json'

const sanitizePermissions = permissions => {
  return {
    ...permissions,
    canCreate: permissions['allow_to_create_audit'] ? true : false,
  }
}

const getUserPermissions = async dispatch => {
  try {
    dispatch({type: UP_PENDING})

    let response = await getUserPermissionsApi()
    dispatch({type: UP_SUCCESS, payload: sanitizePermissions(response)})
  } catch (e) {
    console.log(`Get User Permissions Failed: ${e}`)
    dispatch({type: UP_FAILURE, payload: e})
  }
}

export default getUserPermissions
